import { useI18n } from "../i18n.jsx";

export default function ModuleSelector({ level, moduleNumber, unitNumber, onModuleChange, onUnitChange }) {
  const { t } = useI18n();

  return (
    <div className="setup-stack">
      <div>
        <label className="field-label" htmlFor="module-select">{t("moduleSelector.module")}</label>
        <select id="module-select" value={moduleNumber} onChange={(event) => onModuleChange(Number(event.target.value))}>
          {Array.from({ length: level.modules }, (_, index) => index + 1).map((number) => (
            <option key={number} value={number}>{t("common.module", { number })}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="field-label" htmlFor="unit-select">{t("moduleSelector.unit")}</label>
        <select id="unit-select" value={unitNumber} onChange={(event) => onUnitChange(Number(event.target.value))}>
          <option value={0}>{t("common.allUnits")}</option>
          {Array.from({ length: level.lessonsPerModule }, (_, index) => index + 1).map((number) => (
            <option key={number} value={number}>{t("common.unit", { number })}</option>
          ))}
        </select>
      </div>
    </div>
  );
}
